import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { agentPortalAPI, setAgentPortalToken, setAgentPortalSession } from '@/utils/agentPortalApi';
import AdminPasswordInput from '@/pages/admin/components/AdminPasswordInput';
import AdminToast from '@/pages/admin/components/AdminToast';
import ClickCaptchaField from '@/pages/admin/components/ClickCaptchaField';
import { useAdminToast } from '@/pages/admin/components/useAdminToast';
import '@/styles/agent-portal/agent-portal.css';

export default function AgentPortalLoginPage() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [captchaToken, setCaptchaToken] = useState('');
  const [captchaReady, setCaptchaReady] = useState(false);
  const [captchaKey, setCaptchaKey] = useState(0);
  const [loading, setLoading] = useState(false);
  const { toast, showSuccess, showError, closeToast } = useAdminToast();

  useEffect(() => {
    document.title = 'IPE · Agent控制台';
    return () => {
      document.title = 'IPE';
    };
  }, []);

  const handleCaptchaVerified = useCallback((token) => {
    setCaptchaToken(token);
    setCaptchaReady(true);
    showSuccess('安全验证已通过，可以进行登录', '验证成功');
  }, [showSuccess]);

  const handleCaptchaError = useCallback((message) => {
    setCaptchaToken('');
    setCaptchaReady(false);
    showError(message, '人机验证');
  }, [showError]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!captchaReady || !captchaToken) {
      showError('请先完成安全验证后再登录', '安全验证');
      return;
    }
    setLoading(true);
    try {
      const data = await agentPortalAPI.login(phone, password, captchaToken);
      setAgentPortalToken(data.token);
      setAgentPortalSession(data.role);
      navigate('/ipe/agent/dashboard', { replace: true });
    } catch (err) {
      setCaptchaToken('');
      setCaptchaReady(false);
      setCaptchaKey((k) => k + 1);
      showError(err.message || '登录失败', '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login agent-portal-login">
      <div className="admin-login__bg" />
      <div className="admin-login__grid" />
      <div className="admin-login__orb admin-login__orb--1" />
      <div className="admin-login__orb admin-login__orb--2" />

      <div className="admin-login__container">
        <div className="admin-login__brand">
          <div className="admin-login__logo">IP</div>
          <h1>IPE agent控制台</h1>
          <p>大模型调用监控 · 第三方 API 接口管理</p>
        </div>

        <form className="admin-login__card" onSubmit={handleSubmit}>
          <label>
            管理员手机号
            <input
              className="admin-input"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="请输入 11 位手机号"
              autoComplete="username"
              maxLength={11}
            />
          </label>
          <label>
            登录密码
            <AdminPasswordInput
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="请输入密码"
            />
          </label>
          <div className="admin-login__captcha">
            <span className="admin-login__captcha-label">安全验证</span>
            <ClickCaptchaField
              key={captchaKey}
              scene="agent-login"
              verified={captchaReady}
              onVerified={handleCaptchaVerified}
              onError={handleCaptchaError}
              disabled={loading}
            />
          </div>
          <button type="submit" className="admin-login__submit" disabled={loading}>
            {loading ? '验证中…' : '登录 IPE agent控制台'}
          </button>
        </form>

        <p className="admin-login__footer">IPE agent控制台 · Secure Access</p>
      </div>
      <AdminToast toast={toast} onClose={closeToast} />
    </div>
  );
}
